export default __webpack_public_path__ + "static/media/icon-24-icn-pallet.ea0f0760.svg";